<template>
  <BackgroundImage
    :background="data.heroImage"
    :preload="true"
    :_type="'imageBackground'"
    background-size="full-page"
    light-text
    :class="{
      'pb-24 pt-200px': true,
    }"
  >
    <div
      :class="{
        'container mx-auto grid grid-cols-12 items-center text-www-color-white md:gap-30px': true,
      }"
    >
      <div
        :class="{
          'col-span-12 md:col-span-6': true,
        }"
      >
        <h1
          :class="{
            'mb-4 text-28px font-black lg:text-42px xl:text-60px': true,
          }"
        >
          {{ data.title }}
        </h1>

        <h2
          :class="{
            'text-lg font-normal leading-8': true,
          }"
        >
          {{ data.subtitle }}
        </h2>
      </div>
      <div
        :class="{
          'col-span-12 md:col-span-6': true,
        }"
      >
        <WistiaVideo
          :video="data.video"
          embed-type="popover"
          _type="wistiaVideo"
          :class="{
            'g-0': true,
          }"
        />
      </div>
    </div>
  </BackgroundImage>
</template>

<script lang="ts" setup>
import BackgroundImage from '~/components/Atmos/BackgroundImage/BackgroundImage.vue';
import WistiaVideo from '~/components/Atmos/WistiaVideo/WistiaVideo.vue';
import type { QueryWhyOnshapeResult } from '~/sanity/types';

interface Props {
  data: NonNullable<QueryWhyOnshapeResult>['whyOnshapeHero'];
}

defineProps<Props>();
</script>
